import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TableModule } from 'primeng-lts/table';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { UnitPricesListComponent } from './UnitPricesList.component';
import { InputTextModule } from 'primeng-lts/inputtext';
import { ButtonModule } from 'primeng-lts/button';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule } from 'primeng-lts/calendar';
import { SliderModule } from 'primeng-lts/slider';
import { DialogModule } from 'primeng-lts/dialog';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DropdownModule } from 'primeng-lts/dropdown';
import { ToastModule } from 'primeng-lts/toast';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ContextMenuModule } from 'primeng-lts/contextmenu';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { InputNumberModule } from 'primeng-lts/inputnumber';



@NgModule({
  declarations: [UnitPricesListComponent],
  imports: [WaitLoadingModule, // Servicio  de espera
    TranslateModule,   // Servicio de internacionalización
    CommonModule,
    TableModule,
    // Directivas para dobleclick de botones, autofocus, ...
    OverlayPanelModule,

    PanelModule,
    FormPlycaModule,
    ScrollPanelModule,
    SubHeaderModule,
    BrowserModule,
    BrowserAnimationsModule,

    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    HttpClientModule,
    FormsModule,
    RadioButtonModule,
    InputNumberModule,
    CheckboxModule]
})

export class UnitPricesModule { }
